import BookingStatusCard from './BookingStatusCard';

export default BookingStatusCard;
